/**
 * @file
 * @author dailin01
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext, useCallback } from 'react';
import classNames from 'classnames';
import Tooltip from '../tooltip';
import { isValidElement, cloneElement } from '../_util/reactNode';
import { Item } from './rc-menu';
import MenuContext from './MenuContext';
import { MenuContext as BaseMenuContext } from './rc-menu/context/MenuContext';
const MenuItem = props => {
    var _a;
    const { children, icon, title, tooltipProps } = props, rest = __rest(props, ["children", "icon", "title", "tooltipProps"]);
    const contextValue = useContext(MenuContext);
    const baseMenuContextValue = useContext(BaseMenuContext);
    const { inlineCollapsed } = baseMenuContextValue;
    const { prefixCls, firstLevel } = contextValue;
    let tooltipTitle = title;
    if (typeof title === 'undefined') {
        tooltipTitle = (firstLevel && inlineCollapsed) ? children : '';
    }
    const mergeTooltipProps = Object.assign(Object.assign({}, tooltipProps), { title: tooltipTitle });
    const renderItemChildren = useCallback(() => {
        const wrapNode = <span className={`${prefixCls}-title-content`}>
            <span className={`${prefixCls}-title-content-inner`}>{props.children}</span>
        </span>;
        // 如果是收起 + 没有ICON 显示MenuItem第一个字
        if (!icon || (isValidElement(children) && children.type === 'span')) {
            if (children && firstLevel && inlineCollapsed && typeof children === 'string') {
                return (<div className={`${prefixCls}-inline-collapsed-noicon`}>{children.charAt(0)}</div>);
            }
            return <span className={`${prefixCls}-title-content-inner`}>{props.children}</span>;
        }
        return wrapNode;
    }, [children, firstLevel, icon, inlineCollapsed, prefixCls]);
    return (<Tooltip {...mergeTooltipProps} placement={'right'}>
            <Item {...rest}>
                {cloneElement(icon, {
            className: classNames(isValidElement(icon) ? (_a = icon.props) === null || _a === void 0 ? void 0 : _a.className : '', `${prefixCls}-item-icon`)
        })}
                {renderItemChildren()}
            </Item>
        </Tooltip>);
};
export default MenuItem;
